import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ArchivedFieldsBanner,
  CardsContainer,
  FieldsInfoCard,
  InvoicesSection,
} from '@/modules/payment';
import { useGetFields } from '@/modules/payment/apiHooks';
import { Typography } from '@/shared/components/atoms';
import ExpiredPopup from '@/shared/components/molecules/ExpiredPopup';
import { roles } from '@/shared/constant/roles-and-permissions';
import { useAuth } from '@/shared/hooks/context/auth';
import { IAuthContext } from '@/shared/hooks/context/auth/IAuthContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';
import useCheckSubscriptionStatus from '@/shared/hooks/useCheckSubscriptionStatus';

const Billing = () => {
  const { user } = useAuth();
  const { openModal, closeModal } = useModal();
  const { t } = useTranslation('payment');
  const { data: fieldsData } = useGetFields();
  const showSubscriptionCTA = useCheckSubscriptionStatus();

  // TODO(abdo): remove this once UserHasPermission is refactored
  const rolesWithPermission: IAuthContext.RolesType[] = [
    roles.COMPANY_ADMIN,
    roles.OWNER,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ];
  const hasPermissionToSeeExpiredPopup = rolesWithPermission.includes(
    user?.userGroupId ?? roles.OWNER
  );

  useEffect(() => {
    if (showSubscriptionCTA && hasPermissionToSeeExpiredPopup) {
      setTimeout(() => {
        openModal(<ExpiredPopup />, {
          dismissable: false,
          variant: 'popup',
          onClose: () => {
            closeModal();
            closeModal();
          },
        });
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='flex flex-col'>
      {fieldsData &&
        fieldsData?.freeSlots > 0 &&
        fieldsData.paidFields > fieldsData.activeFields && (
          <ArchivedFieldsBanner {...fieldsData} />
        )}
      <div className='mb-32 flex flex-col'>
        <Typography
          variant='h1'
          weight='semiBold'
          className='text-text-default'
        >
          {t('billing')}
        </Typography>
        <Typography variant='caption' className='text-surface-10'>
          {t('manage-billing-caption')}
        </Typography>
      </div>
      <div className='flex flex-col gap-24'>
        <CardsContainer />
        {fieldsData && <FieldsInfoCard {...fieldsData} />}
        <InvoicesSection />
      </div>
    </div>
  );
};

export { Billing };
